const isProduction = import.meta.env.PROD || /prod/.test(import.meta.env.VITE_APP_URL || '')

export const configs = {
  TRANSFERBANK: {
    platformUrlRedirection: isProduction
      ? 'https://app.transferbank.com.br'
      : 'https://staging.transferbank.com.br',
    acceptedUrls: [
      'https://onboarding.transferbank.com.br',
      'https://onboarding-stag.transferbank.com.br',
      'http://localhost:8080/'
    ],
    institution: 'TRANSFERBANK',
    key: 'TRANSFERBANK',
    color: '#0AA092',
    // codePartner: 'TB',
    GTM_ID: import.meta.env.VITE_APP_GTM_ID
  },
  FX55: {
    platformUrlRedirection: isProduction
      ? 'https://app.fx55.com.br'
      : 'https://staging.fx55.com.br',
    acceptedUrls: [
      'https://onboarding.fx55.com.br',
      'https://onboarding-stag.fx55.com.br',
      'http://localhost:8080/'
    ],
    institution: 'TRANSFERBANK',
    key: 'FX55',
    color: '#0AA092',
    GTM_ID: import.meta.env.VITE_APP_GTM_ID
  },
  DOURADA: {
    platformUrlRedirection: isProduction
      ? 'https://app.dourada.com.br'
      : 'https://staging.dourada.com.br',
    acceptedUrls: ['https://onboarding.dourada.com.br', 'https://onboarding-stag.dourada.com.br'],
    institution: 'DOURADA',
    key: 'DOURADA',
    color: '#EFC132'
  },
  SVN: {
    platformUrlRedirection: isProduction
      ? 'https://app.transferbankfx.com.br'
      : 'https://staging.transferbankfx.com.br',
    acceptedUrls: [
      'https://onboarding-svn.transferbankfx.com.br',
      'https://onboarding-svn-stag.transferbankfx.com.br'
    ],
    institution: 'SVN',
    key: 'SVN',
    color: '#BB9F8B'
  },
  MIRAE: {
    platformUrlRedirection: isProduction
      ? 'https://transferbank.miraeinvest.com.br'
      : 'https://mirae-stag.transferbankfx.com.br',
    acceptedUrls: [
      'https://onboarding-mirae.transferbankfx.com.br',
      'https://onboarding-mirae-stag.transferbankfx.com.br',
      'https://onboarding-transferbank.miraeinvest.com.br'
    ],
    institution: 'MIRAE',
    key: 'MIRAE',
    color: '#F58220',
    GTM_ID: 'GTM-N3KZVQMC'
  },
  NORD: {
    platformUrlRedirection: isProduction
      ? 'https://cambio.nordinvestimentos.com.br'
      : 'https://nord-stag.transferbankfx.com.br',
    acceptedUrls: [
      'https://onboarding-nord.transferbankfx.com.br',
      'https://onboarding-nord-stag.transferbankfx.com.br',
      'https://onboarding-cambio.nordinvestimentos.com.br'
    ],
    institution: 'NORD',
    key: 'NORD',
    color: '#71c8d1'
  },
  MPDI: {
    platformUrlRedirection: isProduction
      ? 'https://app.mapacambio.com.br'
      : 'https://mpdi-stag.transferbankfx.com.br',
    acceptedUrls: [
      'https://onboarding-mpdi.transferbankfx.com.br',
      'https://onboarding-mpdi-stag.transferbankfx.com.br',
      'https://onboarding.mapacambio.com.br'
    ],
    institution: 'MPDI',
    key: 'MPDI',
    color: '#001231'
  },
  OKEGEN: {
    platformUrlRedirection: isProduction
      ? 'https://cambio.okegen.com.br'
      : 'https://okegen-stag.transferbankfx.com.br',
    acceptedUrls: [
      'https://onboarding.okegen.com.br',
      'https://onboarding-okegen.transferbankfx.com.br',
      'https://onboarding-okegen-stag.transferbankfx.com.br'
    ],
    institution: 'OKEGEN',
    key: 'OKEGEN',
    color: '#1C4C80'
  },
  BRDESK: {
    platformUrlRedirection: isProduction
      ? 'https://app.brasildeskcorporate.com.br'
      : 'https://brdesk-stag.transferbankfx.com.br',
    acceptedUrls: [
      'https://onboarding.brasildeskcorporate.com.br',
      'https://onboarding-brasildeskcorporate.transferbankfx.com.br',
      'https://onboarding-brdesk-stag.transferbankfx.com.br'
    ],
    institution: 'BRDESK',
    key: 'BRDESK',
    color: '#718055'
  },
  BRUDER: {
    platformUrlRedirection: isProduction
      ? 'https://app.brudercambio.com.br'
      : 'https://brudercambio-stag.transferbankfx.com.br',
    acceptedUrls: [
      'https://onboarding.brudercambio.com.br',
      'https://onboarding-brudercambio.transferbankfx.com.br',
      'https://onboarding-bruder-stag.transferbankfx.com.br'
    ],
    institution: 'BRUDER',
    key: 'BRUDER',
    color: '#01836D'
  }
}

export const getPlatformFromUrl = () => {
  const currentUrl = window.location.href
  for (const key in configs) {
    if (configs[key].acceptedUrls.some((url) => currentUrl.includes(url))) {
      document.documentElement.style.setProperty('--secondary-color', configs[key].color)
      document.documentElement.style.setProperty('--button-color', setTextColor(configs[key].color))
      return configs[key].key
    }
  }
  return configs['TRANSFERBANK'].key
}

const hexToRgb = (hex) => {
  let r = 0,
    g = 0,
    b = 0
  if (hex.length == 4) {
    r = parseInt(hex[1] + hex[1], 16)
    g = parseInt(hex[2] + hex[2], 16)
    b = parseInt(hex[3] + hex[3], 16)
  } else if (hex.length == 7) {
    r = parseInt(hex[1] + hex[2], 16)
    g = parseInt(hex[3] + hex[4], 16)
    b = parseInt(hex[5] + hex[6], 16)
  }
  return [r, g, b]
}

const calculateLuminance = (r, g, b) => {
  const a = [r, g, b].map(function (v) {
    v /= 255
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)
  })
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722
}

const setTextColor = (hexColor) => {
  const [r, g, b] = hexToRgb(hexColor)
  const luminance = calculateLuminance(r, g, b)
  return luminance > 0.363 ? '#000000' : '#ffffff'
}

export const isIncorrectUrlForRole = (role) => {
  const currentUrl = window.location.href
  const acceptedUrls = Object.values(configs)
    .filter((config) => config.institution === role)
    .flatMap((config) => config.acceptedUrls)
  return !acceptedUrls.some((url) => currentUrl.includes(url))
}

export const platformWhiteLabel = (role, direction) => {
  return configs[role]?.[direction]
}
